import Environment from './environment';

/**
 * 記事関連の処理
 */
let spacer_ary = [];
export default class Article {
  constructor() {
    this.init_spacer();
    this.send_btn_analytics();
    this.eventHandler();
  };

  /**
   * スペーサーの初期値（px）を あらかじめ格納
   */
  set_spacer_ary() {
    $('.wp-block-spacer').each(function () {
      let	height = $(this).css('height');
      spacer_ary.push(height);
    });
  };

  /**
   * スペーサーの値をデバイスによって変換する（PCはpx、SPはvw）
   */
  adjust_spacer() {
    let deviceType = Environment.getDeviceType();
    if (deviceType == 'pc') {
      $('.wp-block-spacer').each(function (i) {
        $(this).css('height', spacer_ary[i]);
      });
    } else  {
      $('.wp-block-spacer').each(function (i) {
        let string_px = spacer_ary[i];
        let int_px = Number(string_px.replace(/[^0-9]/g, '')); // 単位を取り除いて数字だけにする
        let int_px_half = int_px / 2; // 半分の値にする
        let vw = (int_px_half / 375) * 100;
        $(this).css('height', vw + 'vw');
      });
    }
  };

  /**
   * スペーサー初期化
   */
  async init_spacer() {
    let deviceType = Environment.getDeviceType();
    await this.set_spacer_ary();
    if (deviceType == 'sp') {
      this.adjust_spacer();
    }
  };

  /**
   * postID 取得
   * @returns
   */
  get_post_id () {
    let url = location.href;
    let post_id = 0;
    if (url.match(/\?p=/) && url.match(/preview=true/)) { // 未保存プレビューの場合
      post_id = this.getParam('p');
    } else {
      let ary_url = url.split('/');
      post_id = ary_url[ary_url.length - 2];
    }
    return post_id;
  };

  /**
   * URLからパラメータを取得
   * @param {*} name
   * @param {*} url
   * @returns
   */
  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  /**
   * ボタン クリックイベント送信処理
   */
  send_btn_analytics() {
    let post_id = this.get_post_id();
    $('.wp-block-button.is-style-send-analytics .wp-block-button__link').on('click', function () {
      let btn_text = $(this).text();
      gtag('event', 'click', { 'event_category': 'link', 'event_label': post_id + '_モジュール_' + btn_text });
    });
  };

  /**
   * イベントハンドラー
   */
  eventHandler() {
    window.addEventListener('resize', this.adjust_spacer);
  };
}
